import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import { AuctionResultStatus } from '../../services';
import { Button } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';
import { useAppDispatch } from '../../store';
import { ShowResultPanelAction } from '../../store/Result/ActionCreator';

import { Icons } from '@sede-enterprise/shell-ds-react-framework'

const ButtonActionContainer = styled.div`
  .shell-button.shell-button-icon-left {
    padding-left: 0;
  }
  .shell-button-renderer{
    min-height: 33px;
    text-size: 6px;
    border-radius:2px;
    outline:none;
    width:9rem;
  }
  .shell-button-renderer span span{
    font-size:0.75rem;
    margin-left:-2px;
  }
  .shell-button-renderer svg{
    height:24px;
    width:24px;
    margin-left:-10px;
  }
`;

const ViewIconAction = styled(Icons.ZoomIn)`
&.shell-icon {
  display: inline-block;
  margin-top: 0.2rem;
  flex-shrink:0;
  width:25px;
  line-height:25px;
}
path{
  fill:black;
}
`;
export interface IAuctionResultStatusRenderer extends ICellRendererParams { }

const AuctionResultStatusRenderer: React.FC<IAuctionResultStatusRenderer> = (
  props
) => {
  const propertyValue = props.data.auctionResultStatus;
  const dispatch = useAppDispatch();
  if (propertyValue === AuctionResultStatus.CapacityWon) {
    return (
      <ButtonActionContainer>
        <Button
          className="shell-button-renderer" size="xsmall"
          onClick={() => {
            dispatch(ShowResultPanelAction(props.data))
          }} ><ViewIconAction />
          Show Result</Button>
      </ButtonActionContainer>)
  }
  else
    return <span>{propertyValue}</span>;
};
export default AuctionResultStatusRenderer;